import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons/faFileArrowDown';
import { CSVLink } from 'react-csv';
import { TooltipTrigger, Button } from 'react-aria-components';
import { Tooltip } from 'components/tooltip/Tooltip';
import { CsvData } from 'components/app-page/page-toolbar/CsvData';



interface DownloadCsvProps {
	csvData: CsvData,
}


export const DownloadCsv = (props: DownloadCsvProps) => {
	const { headers, data, filename, blockDownload, blockMessage } = props.csvData;

	const allowDownload = !blockDownload && data && data.length > 0 ? true : false;

	return (
		<TooltipTrigger delay={0} isDisabled={blockDownload && blockMessage ? false : true}>
			<Button>
				<CSVLink
					data={data ? data : ''}
					headers={headers}
					separator=';'
					enclosingCharacter=''
					filename={`reporting-web-${filename}-${format(new Date(), 'MMddyyyy-HHmmss')}.csv`}
					className={`toolbar-download-button${allowDownload ? '' : ' disabled'}`}
					aria-disabled={!allowDownload}
					onClick={() => allowDownload}
					target="_blank"
				>
					<FontAwesomeIcon className='toolbar-icon download-icon' icon={faFileArrowDown} aria-disabled={!allowDownload} />
				</CSVLink>
			</Button>
		
			<Tooltip>{blockMessage}</Tooltip>
		</TooltipTrigger>
	)
}